import { render, staticRenderFns } from "./submit_confirm_products.vue?vue&type=template&id=5b342c88&scoped=true"
import script from "./submit_confirm_products.vue?vue&type=script&lang=js"
export * from "./submit_confirm_products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b342c88",
  null
  
)

export default component.exports